import "../Css/groovePQR_pdf.css";
import Groove_pdf_headerPQR from "./Groove_pdf_headerPQR";
import Wld_Consolelog from "../../../utility/common/helpers/ConsoleLog";
import { 
  PQRWeldingProcessTable,
  PQRFillerMetalTable,
  PQRPositionTable
  ,PQRPreheatTable
  ,PQRGasTable
  ,PQRElectricalTable
  ,PQRTechniqueTable
} from "./common";

const Groove_pdf_page2 = ({ pdf, PQRtype, index = 4 }) => {
  const isoverlay = pdf[0]?.wld_WPSType === "Groove" ? false : true;
  const weldingType = isoverlay ? "Overlay" : "Groove";
  const processfour = [pdf[0], pdf[4]]
  
  Wld_Consolelog("pdf4", pdf[0]?.wld_WPSType, processfour);
  Wld_Consolelog("pdf", pdf[index]);
  Wld_Consolelog("pdfffffffffffff", pdf);
  return (
    <div className="MainPDF">
      <Groove_pdf_headerPQR pdf={pdf} />
      
    
      <PQRWeldingProcessTable pdf={processfour} type={weldingType} index={4}/>
      <PQRFillerMetalTable pdf={processfour} type={weldingType} />
      <PQRPositionTable pdf={processfour} />
      <PQRPreheatTable pdf={processfour} />
      <PQRGasTable pdf={processfour} type={weldingType} />
      <PQRElectricalTable pdf={processfour} type={weldingType} />
      <PQRTechniqueTable pdf={processfour} type={weldingType} />

      <div className="WPSfooter" style={{ position: "fixed", top: "2035px", fontFamily: pdf[4] ? "GE-BodyCopy" : "inherit" }}>
        <table className="WPSfooter">
          <tr><td>Page 2 of {pdf[4] ? "3" : "2"}</td></tr>
        </table>
      </div>
    </div>
  );
};

            
              export default Groove_pdf_page2; 